
export default {
    name: 'antecedent-enf-familiaux',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            save_loading: false,
            
            atcd_allergo_p: {
                v_model: []
            },
            fields: [
                'atcd_fratrie', 'allergie_fratrie', 'allergie_fratrie_mention',
                'atopie_fratrie', 'atopie_fratrie_mention', 'atcd_pere',
                'allergie_pere', 'allergier_pere_mention', 'atopie_pere',
                'atopie_pere_mention', 'atcd_mere', 'allergie_mere',
                'allergier_mere_mention', 'atopie_mere', 'atopie_mere_mention'
            ],
        }
    },
    computed: {
        antecedent_enf_familiaux() {
            return this.$store.getters["antecedent_enf_familiaux"];
        },
    },
    mounted() {
        this.listeChampATCDENFfamiliaux()
    },
    methods: {
        initFields() {
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.antecedent_enf_familiaux.length > 0) {
                    v = this.antecedent_enf_familiaux[index]['field_content']
                }
                
                this.atcd_allergo_p.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        async listeChampATCDENFfamiliaux() {
            this.is_loading = true
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_enf_familiaux',
                est_en_cours: true
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                this.initFields()
            })
        },

        saveAntecedent() {
            this.save_loading = true

            let data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_enf_familiaux',
                antecedents: this.atcd_allergo_p.v_model
            }

            this.$store.dispatch('saveConsultationAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDENFfamiliaux()
                }

                this.save_loading = false
            })
        }
    }
}


